<template>
    <div v-if="RecipeNotFound" class="not-found-page">
      <div class="centered">
        <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
        <p>The page you requested could not be found.</p>
      </div>
    </div>
    <div v-else id="pageRecipe" class="Page">
        <h1>{{ TheRecipe.name }} Recipe</h1>
        <RecipeView :Recipe="TheRecipe"></RecipeView>
    </div>
</template>
<script>
import RecipeView from 'src/Modules/Health/Components/Recipe';

export default {
    components: {
        RecipeView
    },
    data() {
        return {
            RecipeID: parseInt(this.$route.params.id),
            RecipeSlug: this.$route.params.slug,
            RecipeDefault: {
                name: '',
                ingredients: [],
                steps: [],
                image: '',
                video: ''
            },
            RecipeLoaded: false
        };
    },
    computed: {
        TheRecipe() {
            let Rec = isNaN(this.RecipeID) ? this.$store.getters.Recipes_GetBySlug(this.RecipeSlug) : this.$store.getters.Recipes_GetByID(this.RecipeID);
            if (typeof Rec === 'undefined' && !this.RecipeNotFound) { this.GetTheRecipe(); }
            return typeof Rec === 'undefined' ? this.RecipeDefault : Rec;
        },
        RecipeNotFound() {
            return this.$store.getters.Recipes_GetIsNotFoundByID(this.RecipeID) || this.$store.getters.Recipes_GetIsNotFoundByID(this.RecipeSlug);
        }
    },
    mounted() {
        this.GetTheRecipe();
    },
    methods: {
        GetTheRecipe() {
            isNaN(this.RecipeID) ? this.$store.dispatch('Recipes_GetBySlug', this.RecipeSlug) : this.$store.dispatch('Recipes_GetByID', this.RecipeID);
        }
    },
    watch: {
        RecipeID() {
            this.GetTheRecipe();
        }
    }
};
</script>
